'use strict';
var parent = require('../../stable/array/from');

module.exports = parent;



//////////////////
// WEBPACK FOOTER
// ./~/core-js/actual/array/from.js
// module id = 1223
// module chunks = 0